import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { apiGradesForParentGet$Json } from 'amoxcalli-academic-api';

import { environment } from '../../../../environments/environment';
import { CalificacionesActions } from './calificaciones.actions';

@Injectable()
export class CalificacionesEffects {
  private readonly actions$ = inject(Actions);
  private readonly http     = inject(HttpClient);

  loadGrades$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CalificacionesActions.loadGrades),
      switchMap(({ studentId }) =>
        apiGradesForParentGet$Json(this.http, environment.serverUrl.academic, { studentId }).pipe(
          map((response) => {
            const grades = (response.body ?? []).map((dto) => ({
              periodId:            dto.periodId ?? '',
              periodName:          dto.periodName ?? '',
              periodNumber:        dto.periodNumber ?? 0,
              subjectId:           dto.subjectId ?? '',
              subjectName:         dto.subjectName ?? '',
              hasData:             dto.hasData ?? false,
              finalGrade:          dto.finalGrade ?? null,
              participationPoints: dto.participationPoints ?? 0,
              rubros: (dto.rubros ?? []).map((r) => ({
                key:   r.key ?? '',
                name:  r.name ?? '',
                pct:   r.pct ?? 0,
                score: r.score ?? 0,
              })),
            }));
            return CalificacionesActions.loadGradesSuccess({ grades });
          }),
          catchError(() =>
            of(CalificacionesActions.loadGradesFailure({ error: 'No se pudieron cargar las calificaciones.' }))
          )
        )
      )
    )
  );
}
